/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
import Button from "../../extras/Button";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import ToggleSwitch from "../../extras/ToggleSwitch";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import Title from "../../extras/Title";
import {
  getAllCategory,
  categoryDelete,
} from "../../../redux/slice/categorySlice";
import { permissionError, warning } from "../../../util/Alert";
import { ReactComponent as Delete } from "../../../assets/icon/delete.svg";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CategoryDialogue from "./CategoryDialogue";
import { ReactComponent as Edit } from "../../../../src/assets/icon/edit.svg";
import { IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import LazyImage from "../../extras/ImageFallback";

const Category = () => {
  const { category, total } = useSelector((state) => state.category);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const [data, setData] = useState([]);
  const hasPermission = useSelector((state) => state.auth.admin.flag);
  useEffect(() => {
    dispatch(getAllCategory());
  }, []);

  useEffect(() => {
    setData(category);
  }, [category]);

  const dispatch = useDispatch();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const [search, setSearch] = useState("");

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  function openImage(imageUrl) {
    window.open(imageUrl, "_blank");
  }

  const categoryTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile d-flex align-items-center justify-content-center">
          <LazyImage
            src={row?.image}
            alt="image"
            // className="cursor-pointer"
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            // onClick={() => openImage(row?.image)}
            height={`100%`}
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.name}</span>
      ),
    },
    {
      Header: "Created At",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.createdAt.split("T")[0]}</span>
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => {
              dispatch(openDialog({ type: "category", data: row }));
            }}
          >
          <IconEdit className="text-secondary" />
          </button>
          <button
            className="btn btn-sm"
            onClick={() => handleDelete(row?._id)}
          >
             <IconTrash className="text-secondary" />
          </button>
        </div>
      ),
    },
  ];

  const handleDelete = (id) => {
    if (!hasPermission) return permissionError();
    const data = warning("Delete");
    data
      .then((logouts) => {
        const yes = logouts.isConfirmed;
        console.log("yes", yes);
        if (yes) {
          dispatch(categoryDelete(id));
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <div className="userPage">
    <div className="user-table mb-3">

    <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5
                className="main-title">
                Category
              </h5>
            </div>
            <div className="d-flex gap-2 justify-content-end w-100">
              <Button
        
        text={`Add category`}
        bIcon={<IconPlus size={18}/>}
        onClick={() => {
          dispatch(openDialog({ type: "category" }));
        }}
      />
            </div>
          </div>
        </div>
      {/* <Title name="Category" /> */}
      
      
        <Table
          data={data}
          mapData={categoryTable}
          PerPage={rowsPerPage}
          Page={page}
          type={"client"}
        />
        <Pagination
          type={"client"}
          serverPage={page}
          setServerPage={setPage}
          serverPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          totalData={data?.length}
        />
      </div>
      {dialogue && dialogueType === "category" && (
        <CategoryDialogue
          setData={setData}
          data={data}
        />
      )}
    </div>
    
  );
};

export default Category;
